import React, { useEffect, useState } from "react";
import { Card, Col, Modal, ModalBody, ModalHeader, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../../../store/slices/commonSlice";
import { readData } from "../../../../service/order/orderService";
import { useLocation } from "react-router-dom";
import dateFormat from "dateformat";
import { DownloadIcon } from "../../../../assets/images/svg/svg";
import { downloadFileFromURL, formatAmount, getParamsFromURL } from "../../../../utils/helper";

function PolicyModal() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [code, setCode] = useState();
  const modalShow = useSelector((state) => state.common.modalShow);
  const policyData = useSelector(
    (state) => state.orders.selectedOrder.policyData || { files: {} }
  );
  useEffect(() => {
    const fetchCode = async () => {
      await getParamsFromURL(location).then((params) => {
        if (params) {
          setCode(params["code"]);
        } else {
          console.error("No parameters found");
        }
      });
    };
    fetchCode();
  }, [location]);

  const handleClose = () => {
    dispatch(openModal(false));
  };

  useEffect(() => {
    readData(code, "ODR");
  }, [code]);

  return (
    <Modal
      show={modalShow}
      onHide={handleClose}
      centered
      backdrop="static"
      keyboard={false}
      size="xl"
    >
      <ModalHeader className="p-3 bg-info-subtle" closeButton>
        <h4 className="modal-head">Policy</h4>
      </ModalHeader>
      <ModalBody>
        <div className="details">
          <Row className="details-wrapper">
            <Col xs="12" md="6">
              <Row className="details-content">
                <Col className="form-head">Policy Number : </Col>
                <Col className="form-data">{policyData.policy_no || "-"}</Col>
              </Row>
            </Col>
            <Col xs="12" md="6">
              <Row className="details-content">
                <Col className="form-head">Status : </Col>
                <Col className="form-data">{policyData.status || "-"}</Col>
              </Row>
            </Col>
            <Col xs="12" md="6">
              <Row className="details-content">
                <Col className="form-head">Insurer : </Col>
                <Col className="form-data">{policyData.oem_name || "-"}</Col>
              </Row>
            </Col>
            <Col xs="12" md="6">
              <Row className="details-content">
                <Col className="form-head">Policy Holder Name : </Col>
                <Col className="form-data">
                  {policyData.policy_holder_name || "-"}
                </Col>
              </Row>
            </Col>
            <Col xs="12" md="6">
              <Row className="details-content">
                <Col className="form-head">Policy Start Date : </Col>
                <Col className="form-data">
                  {policyData.policy_start_date
                    ? dateFormat(policyData.policy_start_date, "dd/mm/yyyy")
                    : "-"}
                </Col>
              </Row>
            </Col>
            <Col xs="12" md="6">
              <Row className="details-content">
                <Col className="form-head">Policy End Date: </Col>
                <Col className="form-data">
                  {" "}
                  {policyData.policy_end_date
                    ? dateFormat(policyData.policy_end_date, "dd/mm/yyyy")
                    : "-"}
                </Col>
              </Row>
            </Col>
            <Col xs="12" md="6">
              <Row className="details-content">
                <Col className="form-head">Premium Insurer : </Col>
                <Col className="form-data">{formatAmount(policyData.premium) || "-"}</Col>
              </Row>
            </Col>
            <Col xs="12" md="6">
              <Row className="details-content">
                <Col className="form-head">Retroactive Date: </Col>
                <Col className="form-data">
                  {policyData.retro_active_date
                    ? dateFormat(policyData.retro_active_date, "dd/mm/yyyy")
                    : "-"}
                </Col>
              </Row>
            </Col>
          </Row>
          {policyData.rejection_summary !== null && (
            <Row className="details-wrapper">
              <Col>
                <Row className="details-content">
                  <Col className="form-head">Rejection Summary : </Col>
                  <Col className="form-data">
                    {policyData.rejection_summary || "-"}
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
          <Row className="details-wrapper">
            {policyData?.files?.policycopy_media_id && (
              <Col xs="12" md="6">
                <Row className="details-content">
                  <Col>
                    <Card className="file-wrapper">
                      <div className="file-content-wrapper">
                        <div>Policy copy</div>
                        <div className="file-content">
                          <div className="filename">
                            {policyData?.files?.policycopy_media_id?.filename}
                          </div>
                          <div
                            className="info-icon-container"
                            onClick={() =>
                              downloadFileFromURL(
                                policyData?.files?.policycopy_media_id
                                  ?.media_url,
                                policyData?.files?.policycopy_media_id?.filename
                              )
                            }
                          >
                            Download <DownloadIcon />
                          </div>
                        </div>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default PolicyModal;
